<template>
  <div class="w-full">
    <vs-table
      maxHeight="68vh"
      noDataText=""
      search
      pagination
      max-items="10"
      :data="controles"
    >
      <template slot="header">
        <vs-row vs-w="12">
          <vs-col vs-w="6">
            <h4 style="color: #b4aa99">Controles</h4>
          </vs-col>
          <vs-col vs-w="6">
            <ModalCadastroControle @update="getControles" />
          </vs-col>
        </vs-row>
      </template>

      <template slot="thead">
        <vs-th sort-key="nome">Controle</vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :state="data[indextr].lixeira == 1 ? 'danger' : ''"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td :data="data[indextr].nome">{{ data[indextr].nome }}</vs-td>
          <vs-td class="actions">
            <ModalEditarControle
              :controle="data[indextr]"
              @update="getControles"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-if="controles.length == 0">
      <div class="con-colors">
        <ul>
          <li class="danger-box">
            <h2 class="p-5" style="color: white !important">
              Nenhum controle cadstrado
            </h2>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ModalCadastroControle from "./cadastro.vue"
import ModalEditarControle from "./editar.vue"

export default {
  data () {
    return {
      controles: []
    }
  },
  methods: {
    async getControles () {
      this.$vs.loading()
      try {
        this.controles = await this.$http.get(`controle`)
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  components: {
    ModalCadastroControle,
    ModalEditarControle
  },
  mounted () {
    this.getControles()
  }
};
</script>

<style>
.col {
  width: auto;
}
.actions {
  width: 60px !important;
}
</style>
